import { Typography } from '@recruit-robin/robin-theme/web-components';

import { useStyles } from './Header.styles';

const Title = ({ name }: { name: string }) => {
  return (
    <Typography variant={(v) => v.heading[4]} color={(c) => c.neutral.variant[80]}>
      {name}
    </Typography>
  );
};

export const Header = ({ title, buttons }: { title: React.ReactNode; buttons: React.ReactNode }) => {
  const classes = useStyles();

  return (
    <div css={classes.header}>
      {title}

      {buttons}
    </div>
  );
};

Header.Title = Title;
